
const initialState = {

    mandatoryFieldsBasicDetails: [
      { type: "Date and Time", valueFilled: false, name: 'workorderDateandTime', isVisible: true },
      { type: "Request Details", valueFilled: false, name: 'requestDetails', isVisible: true },
      // { type: "Location Code", valueFilled: false, name: 'locationCode', isVisible: true },
    ],
  
    assessmentsMandatoryFields: [
      { type: "Task Code", valueFilled: false, name: 'taskCode', isVisible: true },
      { type: "Repair Type", valueFilled: false, name: 'repairType', isVisible: true },
    ],
  
    completionInfoMandatoryFields: [
      { type: "Completion By", valueFilled: false, name: 'completionBy', isVisible: true },
      { type: "Action Taken", valueFilled: false, name: 'actionTaken', isVisible: true },
    ],
    isMandatoryRequiredEnabled: false,
    isViewEnabled: false,
    isauthorized: false
  };
  
  const routineInspecMandatoryFieldReducer = (state = initialState, action) => {
    switch (action.type) {
      case "UPDATE_ROUTINE_INSPECTION_BASIC_DETAILS_MANDATORY_FIELDS":
        return {
          ...state,
          mandatoryFieldsBasicDetails: action.payload,
        };
  
      case "UPDATE_ROUTINE_INSPECTION_ASSESMENTS_MANDATORY_FIELDS":
        return {
          ...state,
          assessmentsMandatoryFields: action.payload,
        };
  
      case "UPDATE_ROUTINE_INSPECTION_COMPLETION_INFO_MANDATORY_FIELDS":
        return {
          ...state,
          completionInfoMandatoryFields: action.payload,
        };
  
      case "CLEAR_MANDATORY_FIELD_ROUTINE_INSPECTION":
        return {};
      default:
        return state;
    }
  };
  
  export default routineInspecMandatoryFieldReducer;
  